import { useSparks } from '../../api/hooks'
import { useAuth } from '../../contexts/AuthContext'

const isLocalDev = import.meta.env.DEV &&
  !import.meta.env.VITE_ENABLE_AUTH &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')

interface SparksBalanceProps {
  onClick?: () => void
}

export default function SparksBalance({ onClick }: SparksBalanceProps) {
  const { isAuthenticated } = useAuth()
  const { data, isLoading } = useSparks()

  if (!isAuthenticated && !isLocalDev) {
    return null
  }

  const balance = data?.balance ?? 0

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="sparks-balance-badge"
      title="Sparks balance"
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/10 backdrop-blur-sm border border-white/10 hover:bg-white/15 hover:border-white/20 transition-colors cursor-pointer"
    >
      <svg
        className="w-4 h-4 text-yellow-400 shrink-0"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M13 3L4 14h7l-2 7 9-11h-7l2-7z" />
      </svg>
      <span className="text-white text-sm font-medium leading-none">
        {isLoading ? '...' : balance.toLocaleString()}
      </span>
    </button>
  )
}
